import { useCallback, useSyncExternalStore } from 'react';
/**
 * Abaixo disto a navegação vira gaveta e o painel de detalhe fica sobre a
 * página (Teams no celular, painel estreito, janela pequena).
 */
export const MEDIA_COMPACT = '(max-width: 1023px)';
/** Acompanha uma media query, como `(max-width: 768px)`. */
export function useMediaQuery(query) {
    const subscribe = useCallback((onChange) => {
        const media = matchMedia(query);
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, [query]);
    return useSyncExternalStore(subscribe, () => matchMedia(query).matches);
}
//# sourceMappingURL=useMediaQuery.js.map